import { Link } from "react-router-dom";

import {
  buildEditLocationHref,
  extractLegacyLocationReference,
  needsLocationUpgrade,
} from "../lib/locationGeo";

// Owner-management notice for legacy-only Location rows (RIC-5.6F3).
// Presentation-only: no network, no ownership derivation.

function LegacyLocationUpgradeNotice({
  propertyId,
  location,
  variant = "full",
}) {
  if (!propertyId || !needsLocationUpgrade(location)) {
    return null;
  }

  const { region, city } = extractLegacyLocationReference(location);
  const href = buildEditLocationHref(propertyId);

  if (variant === "compact") {
    return (
      <div className="geo-location-upgrade geo-location-upgrade--compact">
        <span className="card-badge card-badge--deal geo-location-upgrade__badge">
          <i className="fa-solid fa-location-dot" aria-hidden="true" />
          Локацію не уточнено
        </span>
        <Link className="geo-location-upgrade__cta" to={href}>
          Уточнити локацію
        </Link>
      </div>
    );
  }

  return (
    <div className="ap-helper geo-location-upgrade" role="alert">
      <i className="fa-solid fa-triangle-exclamation" aria-hidden="true" />
      <div>
        <strong>Уточніть розташування</strong>
        <p className="mb-0">
          Локацію цього оголошення ще не прив&apos;язано до КАТОТТГ.
          Виберіть область і населений пункт.
        </p>
        {(region || city) ? (
          <p className="mb-0 mt-1">
            Поточні дані:
            {region ? (
              <>
                {" "}
                Область: {region}
              </>
            ) : null}
            {city ? (
              <>
                {region ? ";" : " "}
                {" "}
                Населений пункт: {city}
              </>
            ) : null}
            .
          </p>
        ) : null}
        <p className="mb-0 mt-2">
          <Link className="geo-location-upgrade__cta" to={href}>
            Уточнити локацію
          </Link>
        </p>
      </div>
    </div>
  );
}

export default LegacyLocationUpgradeNotice;
